var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgPresto = function SvgPresto(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 47.25 51.73"
  }, props), _defs || (_defs = React.createElement("defs", null, React.createElement("linearGradient", {
    id: "presto_svg__linear-gradient-9",
    x1: 21.09,
    y1: 21.79,
    x2: 20.28,
    y2: 52.44,
    xlinkHref: "#presto_svg__linear-gradient-7"
  }), React.createElement("linearGradient", {
    id: "presto_svg__linear-gradient",
    x1: 29.79,
    y1: -10.01,
    x2: 29.42,
    y2: 4.21,
    gradientTransform: "rotate(-3.67 471.922 -106.112)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#33bcc7"
  })), React.createElement("linearGradient", {
    id: "presto_svg__linear-gradient-2",
    x1: 30.87,
    y1: -9.52,
    x2: 30.96,
    y2: 1.02,
    gradientTransform: "rotate(-3.67 471.922 -106.112)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#e1eff8"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#33bcc7"
  })), React.createElement("linearGradient", {
    id: "presto_svg__linear-gradient-3",
    x1: 393.86,
    y1: 121.28,
    x2: 393.37,
    y2: 139.8,
    gradientTransform: "rotate(86.33 268.182 -127.617)",
    xlinkHref: "#presto_svg__linear-gradient"
  }), React.createElement("linearGradient", {
    id: "presto_svg__linear-gradient-4",
    x1: 393.61,
    y1: 122.01,
    x2: 393.7,
    y2: 133.42,
    gradientTransform: "rotate(86.33 268.182 -127.617)",
    xlinkHref: "#presto_svg__linear-gradient-2"
  }), React.createElement("linearGradient", {
    id: "presto_svg__linear-gradient-5",
    x1: 11.46,
    y1: 20.46,
    x2: 11.18,
    y2: 30.78,
    xlinkHref: "#presto_svg__linear-gradient"
  }), React.createElement("linearGradient", {
    id: "presto_svg__linear-gradient-6",
    x1: 3.9,
    y1: -8.75,
    x2: 3.95,
    y2: -2.72,
    xlinkHref: "#presto_svg__linear-gradient-2"
  }), React.createElement("linearGradient", {
    id: "presto_svg__linear-gradient-7",
    x1: 9.9,
    y1: 0.72,
    x2: 9.65,
    y2: 9.95,
    gradientTransform: "rotate(45.01 -21.613 28.75)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "#e5f3fc"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#36c6d2"
  })), React.createElement("linearGradient", {
    id: "presto_svg__linear-gradient-8",
    x1: 14.94,
    y1: -8.09,
    x2: 15.06,
    y2: 6.76,
    xlinkHref: "#presto_svg__linear-gradient-2"
  }), React.createElement("radialGradient", {
    id: "presto_svg__radial-gradient-3",
    cx: 22.47,
    cy: 21.01,
    r: 46.03,
    gradientTransform: "rotate(-3.67 471.922 -106.112)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.32,
    stopColor: "#29b4aa"
  }), React.createElement("stop", {
    offset: 0.77,
    stopColor: "#317dbe"
  })), React.createElement("radialGradient", {
    id: "presto_svg__radial-gradient-2",
    cx: 12,
    cy: 1.38,
    r: 22.35,
    gradientTransform: "rotate(-3.67 471.922 -106.112)",
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.32,
    stopColor: "#30d5c9"
  }), React.createElement("stop", {
    offset: 0.77,
    stopColor: "#3993df"
  })), React.createElement("radialGradient", {
    id: "presto_svg__radial-gradient",
    cx: 75.87,
    cy: 72.43,
    r: 149.17,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0.32,
    stopColor: "#171f3d"
  }), React.createElement("stop", {
    offset: 0.48,
    stopColor: "#224e71"
  }), React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2c78a0"
  }), React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3397c2"
  }), React.createElement("stop", {
    offset: 0.92,
    stopColor: "#37a9d6"
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "#39b0de"
  })), React.createElement("style", null, ".presto_svg__cls-7{opacity:.95}"))), React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, React.createElement("g", {
    id: "presto_svg__Layer_2",
    "data-name": "Layer 2"
  }, React.createElement("g", {
    id: "presto_svg__Logos"
  }, _path || (_path = React.createElement("path", {
    d: "M23.63 50.73a8.2 8.2 0 01-4.05-1.07l-7.18-4.14-7.35-4.25a8.14 8.14 0 01-4-7V17.48a8.09 8.09 0 014.05-7l14.48-8.39a8.07 8.07 0 018.1 0l14.52 8.38a8.13 8.13 0 014 7v16.78a8.18 8.18 0 01-4 7l-14.52 8.4a8.16 8.16 0 01-4.05 1.08z",
    fill: "#fff"
  })), _path2 || (_path2 = React.createElement("path", {
    d: "M23.63 50.73a8.2 8.2 0 01-4.05-1.07l-7.18-4.14-7.35-4.25a8.14 8.14 0 01-4-7V17.48a8.09 8.09 0 014.05-7l14.48-8.39a8.07 8.07 0 018.1 0l14.52 8.38a8.13 8.13 0 014 7v16.78a8.18 8.18 0 01-4 7l-14.52 8.4a8.16 8.16 0 01-4.05 1.08z",
    fill: "url(#presto_svg__radial-gradient)"
  })), _path3 || (_path3 = React.createElement("path", {
    d: "M23.63 2a7.07 7.07 0 013.55 1l14.52 8.34a7.09 7.09 0 013.55 6.14v16.76a7.16 7.16 0 01-3.55 6.17l-14.52 8.38a7.17 7.17 0 01-7.1 0l-7.18-4.14L6.64 41l-1.09-.62A7.14 7.14 0 012 34.24V17.48a7.06 7.06 0 013.55-6.14L20.08 3a7 7 0 013.55-1m0-2a9.15 9.15 0 00-4.56 1.23L4.55 9.61A9.09 9.09 0 000 17.48v16.76a9.16 9.16 0 004.55 7.9l1.09.62 6.26 3.62 7.18 4.14a9.14 9.14 0 009.09 0l14.53-8.38a9.2 9.2 0 004.55-7.9V17.48a9.11 9.11 0 00-4.55-7.87L28.18 1.23A9.11 9.11 0 0023.63 0z",
    fill: "#b9e8ee"
  })), _path4 || (_path4 = React.createElement("path", {
    d: "M36.33 22.05c.84-.36 2.81-3.45 2.81-3.45s-.73 3.59-.38 4.43 3.45 2.8 3.45 2.8-3.67-.7-4.42-.38S35 28.9 35 28.9s.69-3.67.37-4.45-3.44-2.78-3.44-2.78 3.56.74 4.4.38z",
    fill: "url(#presto_svg__linear-gradient)"
  })), _path5 || (_path5 = React.createElement("path", {
    d: "M39.14 18.6s-.73 3.59-.38 4.43 3.45 2.8 3.45 2.8-3.67-.7-4.42-.38S35 28.9 35 28.9z",
    fill: "url(#presto_svg__linear-gradient-2)"
  })), _path6 || (_path6 = React.createElement("path", {
    d: "M19.8 11.52c1.24-.34 4.55-4.26 4.55-4.26s-1.7 4.84-1.35 6.07 4.25 4.56 4.25 4.56-5-1.67-6.07-1.37-4.55 4.25-4.55 4.25 1.66-5 1.35-6.11-4.24-4.51-4.24-4.51 4.82 1.7 6.06 1.37z",
    fill: "url(#presto_svg__linear-gradient-3)"
  })), _path7 || (_path7 = React.createElement("path", {
    d: "M24.35 7.26s-1.7 4.84-1.35 6.07 4.25 4.56 4.25 4.56-5-1.67-6.07-1.37-4.55 4.25-4.55 4.25z",
    fill: "url(#presto_svg__linear-gradient-4)"
  })), _path8 || (_path8 = React.createElement("path", {
    d: "M10 25c-.2-.66-2.31-2.37-2.31-2.37s2.57.84 3.23.65 2.37-2.32 2.37-2.32a12.68 12.68 0 00-.66 3.24c.18.59 2.32 2.37 2.32 2.37a12.31 12.31 0 00-3.26-.65c-.61.18-2.35 2.3-2.35 2.3s.88-2.61.66-3.22z",
    fill: "url(#presto_svg__radial-gradient-2)"
  })), _path9 || (_path9 = React.createElement("path", {
    d: "M10 25c-.2-.66-2.31-2.37-2.31-2.37s2.57.84 3.23.65 2.37-2.32 2.37-2.32a12.68 12.68 0 00-.66 3.24c.18.59 2.32 2.37 2.32 2.37a12.31 12.31 0 00-3.26-.65c-.61.18-2.35 2.3-2.35 2.3s.88-2.61.66-3.22z",
    fill: "url(#presto_svg__linear-gradient-5)"
  })), _path10 || (_path10 = React.createElement("path", {
    d: "M7.72 22.61s2.57.84 3.23.65 2.37-2.32 2.37-2.32a12.68 12.68 0 00-.66 3.24c.18.59 2.32 2.37 2.32 2.37z",
    fill: "url(#presto_svg__linear-gradient-6)"
  })), _path11 || (_path11 = React.createElement("path", {
    d: "M21 35.69l-8 9-1-.58L6.56 41l8.88-10.1a26.3 26.3 0 004.64 4.17c.28.22.58.41.88.62z",
    fill: "url(#presto_svg__radial-gradient-3)"
  })), _path12 || (_path12 = React.createElement("path", {
    transform: "rotate(-48.68 17.822 33.747)",
    fill: "url(#presto_svg__linear-gradient-7)",
    d: "M16.76 30.08h2.12v7.33h-2.12z"
  })), _path13 || (_path13 = React.createElement("path", {
    d: "M29.08 26.47l-7.81 8.9-5.5-4.84 7.81-8.9a1.84 1.84 0 012.59-.17l2.74 2.43a1.82 1.82 0 01.17 2.58z",
    fill: "url(#presto_svg__linear-gradient-8)",
    opacity: 0.95
  })), React.createElement("path", {
    d: "M29.08 26.46L21 35.69l-7.93 9-1.07-.58 8.12-9 8.29-9.23a1.82 1.82 0 00-.16-2.57l.71.62a1.82 1.82 0 01.12 2.53z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "url(#presto_svg__linear-gradient-9)"
  })))));
};
export default __webpack_public_path__ + "328db59871460aa232d499b1fcbaf75b.svg";
export { SvgPresto as ReactComponent };